import { ExperimentControlVariant } from './types';

export const FEATURE_FLAGS_OVERRIDE_PARAM = 'feature-flags';
export const FEATURE_FLAGS_OVERRIDE_ASSIGNATOR = ':';
export const FEATURE_FLAGS_OVERRIDE_SEPARATOR = ',';

export const AB_TESTS_CONTROL: ExperimentControlVariant = 'control';

export const GB_COOKIE_NAME = 'gbuuid';

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/Accept
export const ACCEPT_HEADER = 'accept';
export const ACCEPT_HEADER_DOCUMENT_TYPE = 'text/html';

export const SET_COOKIE_HEADER = 'set-cookie';
export const COOKIE_HEADER = 'cookie';

export const AB_TEST_ERROR = '[AB test error]';

export const GROWTHBOOK_PAYLOAD_PATH = '/worker/growthbook-payload';
